import React, { FC, useState } from 'react';
import { IconButton, TextField } from '@mui/material';
import { LabelWrapper, StyledLabel } from './Translation.styles';
import { TranslationEditModal } from './TranslationEditModal';
import { TranslateIcon } from '../../../assets/icons/Icons';
import { theme } from '../../../theme';

interface TranslatableTextFieldProps {
    label: string;
    value: string;
    onChange: (newValue: string) => void;
    entityType: string;
    entityId: string;
    property: string;
    nestedId?: string[];
    hoverText?: string;
    textFieldProps?: Partial<React.ComponentProps<typeof TextField>>;
}

const TranslatableTextField: FC<TranslatableTextFieldProps> = ({
    label,
    value,
    onChange,
    entityType,
    entityId,
    property,
    nestedId,
    hoverText,
    textFieldProps,
}) => {
    const [open, setOpen] = useState(false);
    const handleOpenModal = () => setOpen(true);
    const handleCloseModal = () => setOpen(false);

    return (
        <>
            <LabelWrapper>
                <StyledLabel variant="subtitle2">{label}</StyledLabel>
            </LabelWrapper>
            <TextField
                fullWidth
                variant="outlined"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                slotProps={{
                    input: {
                        endAdornment: (
                            <IconButton
                                onClick={handleOpenModal}
                                size="small"
                                sx={{
                                    border: `1px solid ${theme.palette.primary.main}`,
                                    borderRadius: '6px',
                                    padding: '4px',
                                    ml: 1,
                                }}
                            >
                                <TranslateIcon colorHex={theme.palette.primary.main} />
                            </IconButton>
                        ),
                    },
                }}
                {...textFieldProps}
            />
            <TranslationEditModal
                open={open}
                onClose={handleCloseModal}
                entityType={entityType}
                entityId={entityId}
                property={property}
                nestedId={nestedId}
            />
        </>
    );
};

export default TranslatableTextField;
